import { Group, Text, UnstyledButton } from '@mantine/core';
import { ToolbarProps, View } from 'react-big-calendar';
import { IconFilter, IconFilterOff } from '@tabler/icons-react';
import classes from './SchedulingCalendarToolbar.module.css';
import CalendarActions from './CalendarActions';
import CalendarNavigationButtons from './CalendarNavigationButtons';
import CalendarDateTitle from './CalendarDateTitle';
import CalendarViewInput from './CalendarViewInput';
import { AppointmentEvent } from '../types';

type ExtendedToolbarProps = ToolbarProps<AppointmentEvent, object> & {
  isShowingFilterForm: boolean;
  onSetShowingFilterForm: (value: boolean) => void;
  onSetView: (view: View) => void;
  isShowingAvailabilityList?: boolean;
  onSetShowingAvailabilityList?: (value: boolean) => void;
  onOpenAvailability: () => void;
  onOpenAppointment: () => void;
  onOpenBlock: () => void;
};

export default function SchedulingCalendarToolbar({
  view,
  date,
  isShowingFilterForm,
  onNavigate,
  onSetShowingFilterForm,
  onSetView,
  isShowingAvailabilityList = false,
  onSetShowingAvailabilityList,
  onOpenAppointment,
  onOpenAvailability,
  onOpenBlock,
}: ExtendedToolbarProps) {
  const handleToggleFilterForm = () => {
    onSetShowingFilterForm(!isShowingFilterForm);
  };

  const handleToggleAvailabilityList = () => {
    if (onSetShowingAvailabilityList) {
      onSetShowingAvailabilityList(!isShowingAvailabilityList);
    }
  };

  return (
    <Group p={16} style={{ borderTop: '1px solid #e0e0e0' }} justify="space-between">
      <Group>
        {!isShowingAvailabilityList && !isShowingFilterForm && (
          <UnstyledButton className={`${classes.actionButton} ${classes.actionGroup}`} onClick={handleToggleFilterForm}>
            <IconFilter size={16} />
          </UnstyledButton>
        )}
        {isShowingAvailabilityList && (
          <UnstyledButton className={`${classes.actionButton} ${classes.actionGroup}`} onClick={handleToggleFilterForm}>
            {isShowingFilterForm ? <IconFilterOff size={16} /> : <IconFilter size={16} />}
          </UnstyledButton>
        )}
        {!isShowingAvailabilityList && (
          <>
            <CalendarDateTitle view={view} date={date} />
            <CalendarNavigationButtons onNavigate={onNavigate} />
          </>
        )}
      </Group>
      <Group>
        {!isShowingAvailabilityList && (
          <UnstyledButton
            className={`${classes.actionButton} ${classes.actionGroup}`}
            onClick={handleToggleAvailabilityList}
          >
            <Text fw={600}>Availability list</Text>
          </UnstyledButton>
        )}
        {isShowingAvailabilityList && (
          <UnstyledButton
            className={`${classes.actionButton} ${classes.actionGroup}`}
            onClick={handleToggleAvailabilityList}
          >
            <Text fw={600}>Calendar View</Text>
          </UnstyledButton>
        )}

        {!isShowingAvailabilityList && <CalendarViewInput view={view} onSetView={onSetView} />}

        <CalendarActions
          onOpenAppointment={onOpenAppointment}
          onOpenAvailability={onOpenAvailability}
          onOpenBlock={onOpenBlock}
        />
      </Group>
    </Group>
  );
}
